export const useStyles = ({ windowHeight, headerSizeInRem, fs }: { windowHeight: number; headerSizeInRem: number; fs: number }) => {
    const appWrapper = {
        margin: 0,
        padding: 0,
        backgroundColor: 'background.default',
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    };

    const appWrapperContent = {
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        backgroundColor: { xs: 'transparent', md: 'background.paper' },
        boxShadow: { xs: 'none', md: '0 4px 20px rgba(0, 0, 0, 0.05)' },
        border: { xs: 'none', md: '1px solid' },
        borderColor: { md: 'divider' },
        borderRadius: { xs: 0, md: 2 },
        paddingX: { xs: 1.5, sm: 2, md: 3, lg: 4 },
        paddingY: { xs: 2, md: 3 },
        minHeight: `${windowHeight - 129 - headerSizeInRem * fs}px`,
        marginBottom: { xs: 0, md: 3 },
        overflowX: 'clip',
    };

    const navBarWrapper = {
        marginBottom: { xs: 1, sm: 2 },
    };

    const contentWrapper = {
        marginTop: `${headerSizeInRem}rem`,
    };

    return {
        appWrapper,
        appWrapperContent,
        navBarWrapper,
        contentWrapper,
    };
};
